module.exports = __webpack_public_path__ + "static/media/icon3.b72e3566.svg";